import { ConditionalLink } from '@app/common/src/components/conditional-link'
import { MenuAnchor } from './menu-anchor'
import { MenuItemLink } from '../menu-item-data'
import { SubmenuListItem } from './styled'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { forwardRef } from 'react'
import { useSubmenuItem } from '../hooks/use-submenu-item'

type SubmenuItemProps = {
  colSpan?: number
  item: MenuItemLink
}

export const SubmenuItem = forwardRef<HTMLLIElement, SubmenuItemProps>(({ colSpan, item }, ref) => {
  const { onItemClicked, onKeyDown } = useSubmenuItem(item)
  const condition = item.isExternal === true
  return (
    <ConditionalLink condition={condition} href={item.href}>
      <SubmenuListItem
        colSpan={colSpan}
        role="menuitem"
        ref={ref}
        tabIndex={0}
        onClick={onItemClicked}
        onKeyDown={onKeyDown}
      >
        <MenuAnchor menuItem={item}>
          <Text color="inherit" variant="navigation/header" textAlign="left" component="div" mb={2}>
            {item.label}
          </Text>
          {item.description && (
            <Text
              color="inherit"
              variant="body/small"
              textAlign="left"
              component="div"
              lineHeight="1.6em"
              letterSpacing={'-.01em'}
            >
              {item.description}
            </Text>
          )}
        </MenuAnchor>
      </SubmenuListItem>
    </ConditionalLink>
  )
})

SubmenuItem.displayName = 'SubmenuItem'
